import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class UrlCaptureGuard implements CanActivate {
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    
    // Capture all route parameters and query params for any route
    const fullUrl = state.url;
    const params = route.params;
    const queryParams = route.queryParams;
    
    // Store in sessionStorage to preserve across navigation
    // Wrap in try-catch for iframe restrictions
    try {
      sessionStorage.setItem('originalFullUrl', fullUrl);
      sessionStorage.setItem('originalParams', JSON.stringify(params));
      sessionStorage.setItem('originalQueryParams', JSON.stringify(queryParams));
      
      // For all routes, capture common parameters
      // This replaces the conditional check for specific paths
      
      // Capture authId (present in login, remember, signup routes)
      if (params['authId']) {
        sessionStorage.setItem('originalAuthId', params['authId']);
      }
      
      // Capture activateCode (present in activate routes)
      if (params['activateCode']) {
        sessionStorage.setItem('originalActivateCode', params['activateCode']);
      }
      
      // Capture common query parameters
      if (queryParams['source']) {
        sessionStorage.setItem('originalSource', queryParams['source']);
      }
      
      if (queryParams['sessionId']) {
        sessionStorage.setItem('originalSessionId', queryParams['sessionId']);
      }
      
      if (queryParams['callback']) {
        sessionStorage.setItem('originalCallback', queryParams['callback']);
      }
      
      if (queryParams['product']) {
        sessionStorage.setItem('originalProduct', queryParams['product']);
      }
      
      if (queryParams['email']) {
        sessionStorage.setItem('originalEmail', queryParams['email']);
      }
      
      if (queryParams['activationId']) {
        sessionStorage.setItem('originalActivationId', queryParams['activationId']);
      }
      
      // Capture noAutoDialog flag (for testing)
      if (queryParams['noAutoDialog']) {
        sessionStorage.setItem('originalNoAutoDialog', queryParams['noAutoDialog']);
      }
    } catch (error) {
      console.warn('sessionStorage not accessible in UrlCaptureGuard:', error);
      // Continue execution even if sessionStorage fails
    }
    
    // Always return true to allow navigation to continue
    return true;
  }
}